const pages = [
  /* 首页 */
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '@/views/api/index')
  },
  {
    /* API文档 */
    path: '/api',
    name: 'API',
    component: () => import(/* webpackChunkName: "api" */ '@/views/api/api-page')
  }
]
export default pages
